import {
  ProcessStepPosition,
  ProcessStepState,
  ProcessStepStatus
} from "shared/types/ProcessStep"

export function getProcessStepPosition(
  index: number,
  activeIndex: number
): ProcessStepPosition {
  if (activeIndex < 0) {
    return ProcessStepPosition.FUTURE
  }
  if (index < activeIndex) {
    return ProcessStepPosition.PAST
  }
  if (index === activeIndex) {
    return ProcessStepPosition.CURRENT
  }
  return ProcessStepPosition.FUTURE
}

// Status is ignored outside PAST so a caller can state a domain fact unconditionally
// (e.g. "no dimensioning result -> SKIPPED") without re-deriving position, and so the
// fact does not surface while the user is still on or before that step.
export function resolveProcessStepState(
  position: ProcessStepPosition,
  status?: ProcessStepStatus
): ProcessStepState {
  switch (position) {
    case ProcessStepPosition.CURRENT:
      return ProcessStepState.CURRENT
    case ProcessStepPosition.FUTURE:
      return ProcessStepState.FUTURE
    case ProcessStepPosition.PAST:
      switch (status) {
        case ProcessStepStatus.SKIPPED:
          return ProcessStepState.SKIPPED
        case ProcessStepStatus.FAILED:
          return ProcessStepState.FAILED
        default:
          return ProcessStepState.DONE
      }
    default:
      return ProcessStepState.FUTURE
  }
}
